import { DocumentReference } from './document-reference';
import { Document } from './document';
import { Sport } from '../enums';
import { ServiceYearMember } from './service-year-member';

export class SportTeam extends Document  {
    
    approver: DocumentReference;

    church: DocumentReference;

    isApproved: boolean;
    
    league: DocumentReference;
    memberList: ServiceYearMember[];

    sport: Sport;
    sportName: string;

    status: string;
}
